import { Column } from 'app/design/primitives/box';
import { Placeholder, PlaceholderLine, ShineOverlay } from 'app/overrides/rn-placeholder';
import { theme } from './shared';

export function ProfileHeroSkeleton() {
  return (
    <Column alignItems="center" style={{ paddingBottom: theme.spacing['spacing.general.x6'] }}>
      <Placeholder Animation={ShineOverlay}>
        <PlaceholderLine style={{ height: 80, width: 80, borderRadius: 40, alignSelf: 'center' }} />
        <PlaceholderLine
          style={{
            height: 14,
            width: 120,
            borderRadius: theme.borderRadii['radius.sm'],
            alignSelf: 'center',
            marginTop: theme.spacing['spacing.general.x2'],
          }}
        />
      </Placeholder>
    </Column>
  );
}
